import { ReportFilters } from "../../../domain/models/report-filters";
import { StateCreator } from "zustand";

export interface FetchReportFiltersComponentInterface {
  reportFiltersComponent: ReportFilters;
  fetchReportFiltersComponent: Function;
  resetReportFiltersComponent: Function;
}

const initialStates = {
  reportFiltersComponent: {} as ReportFilters,
};

export const useFetchReportFiltersComponentSlice: StateCreator<
  FetchReportFiltersComponentInterface
> = (set) => ({
  reportFiltersComponent: initialStates.reportFiltersComponent,

  fetchReportFiltersComponent: (filters: Partial<ReportFilters>) => {
    set((state) => ({
      reportFiltersComponent: {
        ...state.reportFiltersComponent,
        ...filters,
      },
    }));
  },

  resetReportFiltersComponent: () => {
    set({ reportFiltersComponent: initialStates.reportFiltersComponent });
  },
});
